import { useContext } from 'react';
import type { LabelProps } from '../Label';
import { Label } from '../Label';
import { EditableTextContext } from './EditableTextRoot';

export type EditableTextLabelProps = Omit<LabelProps, 'disabled' | 'htmlFor' | 'required'>;

export const EditableTextLabel = ({ ...props }: EditableTextLabelProps) => {
  const context = useContext(EditableTextContext);
  if (!context) {
    throw new Error('EditableTextLabel must be used within an EditableTextRoot context');
  }
  const { id, label, isEditing } = context;

  return (
    <Label
      {...(isEditing && { htmlFor: id })} // only render `for` attr when editing
      {...props}
    >
      {label}
    </Label>
  );
};
